// extracted by mini-css-extract-plugin
module.exports = {"button":"MerchandisersList_button__sWW9d","addButtonWrapper":"MerchandisersList_addButtonWrapper__1zEhi","addButton":"MerchandisersList_addButton__1aGut"};